@import "../../common/css/variable.css";

:host {
  font-size: 30px;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

:host([is-vertical]) {
  font-size: 30px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.jackery-loading-spinner {
  display: block;
  fill: currentcolor;
  overflow: hidden;
  width: 1em;
  height: 1em;
  margin: auto;
  color: #c8c9cc;
}

.jackery-loading-text {
  text-indent: 8px;
  color: var(--text-secondary-color);
  font-size: var(--font-base);
}

:host([is-vertical]) .jackery-loading-text {
  margin-left: 0;
  margin-top: 8px;
  text-indent: 0;
}

slot:empty .jackery-loading-text {
  font-size: 0;
  margin: 0;
}